<div class="programers_content">
    <div class="sub_content">
        <h1 class="title">
            Programmes<br>
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bottom_img.png" class="bottom_img_content" alt="">
        </h1>
        <div class="img_txt_list boysImg_deskView">

            <div class="program_img_list_content">
                <div class="row">
                    <div class="col-md-3">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="https://cdn.zeelearn.com/pmcontent/kidzee/pg1.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/playgroup.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">PlayGroup</div>
                                <p>Children in this age group as identified as Toddlers. Children are born curious.They begin to explore the...</p>
                                <p class="read_more" routerLink="/playgroup">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">2 - 3 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div>
                                <p class="text-center mt-2"> (based on respective State regulations)</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="https://cdn.zeelearn.com/pmcontent/kidzee/pg2.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/nursery.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Nursery</div>
                                <p>The child is now identified as a Pre-schooler. (Mandatory level 1 of Foundational Stage as per NEP)...                                </p>
                                <p class="read_more" routerLink="nursery">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">3 - 4 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div>
                                <p class="text-center mt-2">(based on respective State regulations)
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="https://cdn.zeelearn.com/pmcontent/kidzee/pg3.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/jk.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Junior KG. / Senior KG.</div>
                                <p>This is level 2 and 3 of Foundational Stage 1 - Mandatory as per NEP...</p>
                                <p class="read_more" routerLink="kindergarten">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">4 - 5 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">4 Hours/Day</div>
                                    </div>
                                </div>
                                <div class="bottom_btn_list mt-2">
                                    <div class="bottom_btn">
                                        <div class="admission_text"> Admission Age Group</div>
                                        <div class="years_text">5 - 6 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">4 Hours/Day</div>
                                    </div>
                                </div>
                                <p class="text-center mt-1">(based on respective State regulations)</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="https://cdn.zeelearn.com/pmcontent/kidzee/pg4.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/teacher.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Teacher Training Programme</div>
                                <p>Zee Learn Preschool Teacher Training Programme has set unrivalled standards in the CDE (Child Development & Education) space as a leader in ECCE (Early Childhood Care & Education)...</p>
                              
                                <p class="read_more" routerLink="teacher-training-programme">Read More</p>
                                <!-- <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">1.5 - 2.5 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="mobile_res">
            <div class="container my-4">
                <div class="contain">
                    <div id="carousel2" class="owl-carousel owl-theme">
                      <div class="item">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="https://cdn.zeelearn.com/pmcontent/kidzee/pg1.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/playgroup.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Playgroup</div>
                                <p>Children in this age group as identified as Toddlers. Children are born curious.
                                    They begin to explore the environment...</p>
                                <p class="read_more" routerLink="/playgroup">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">1.5 - 2.5 Years</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div>
                                <p class="text-center mt-2"> (based on respective State regulations)</p>
                            </div>
                        </div>
                      </div>
                      <div class="item">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="https://cdn.zeelearn.com/pmcontent/kidzee/pg2.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/nursery.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Nursery</div>
                                <p>The child is now identified as a Pre-schooler. (Mandatory level 1 of Foundational Stage as per NEP)...                                </p>
                                <p class="read_more" routerLink="nursery">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">2.5 - 3.5 Years*</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">3 Hours/Day</div>
                                    </div>
                                </div>
                                <p class="text-center mt-2">(based on respective State regulations)
                                </p>
                            </div>
                        </div>
                    </div>
                      <div class="item">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="https://cdn.zeelearn.com/pmcontent/kidzee/pg3.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/jk.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Junior KG. / Senior KG.</div>
                                <p>This is level 2 and 3 of Foundational Stage 1 - Mandatory as per NEP...</p>
                                <p class="read_more" routerLink="kindergarten">Read More</p>
                                <div class="bottom_btn_list">
                                    <div class="bottom_btn">
                                        <div class="admission_text">Admission Age Group</div>
                                        <div class="years_text">Jr.Kg. 4 - 5 Years*</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">4 Hours/Day</div>
                                    </div>
                                </div>
                                <div class="bottom_btn_list mt-2">
                                    <div class="bottom_btn">
                                        <div class="admission_text"> Admission Age Group</div>
                                        <div class="years_text">Sr.Kg. 5 - 6 Years*</div>
                                    </div>
                                    <div class="bottom_btn">
                                        <div class="admission_text">Duration</div>
                                        <div class="years_text">4 Hours/Day</div>
                                    </div>
                                </div>
                                <p class="text-center mt-1">(based on respective State regulations)</p>
                            </div>
                        </div>
                      </div>
                      <div class="item">
                        <div class="card_content">
                            <div class="img_content">
                                <img src="https://cdn.zeelearn.com/pmcontent/kidzee/pg4.png" width="100%" alt="">
                            </div>
                            <div class="bg_banner_content">
                                <div class="d-flex justify-content-center icon_list_content">
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/teacher.png" class="icon_list"
                                        alt="">
                                </div>
                                <div class="card_title">Teacher Training Programme</div>
                                <p>Zee Learn Preschool Teacher Training Programme has set unrivalled standards in the CDE (Child Development & Education) space as a leader in ECCE (Early Childhood Care & Education)... 
                                </p>
                                <p class="read_more" routerLink="teacher-training-programme">Read More</p>
                                
                            </div>
                        </div>
                      </div>
                    </div>

                    
            </div>
        </div>

    </div>
</div>